









import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    components: {
    },
    props: {
        toggleModel: Boolean,
    },
    setup(props, context) {

        const model = computed({
            get() {
                return props.toggleModel;
            },
            set(newValue) {
                context.emit('toggleBtnClicked', newValue);
            },
        });

        return {
            model,
        };
    }
});
